<!--
 * @Author: Tahiti
 * @Date: 2025-10-21 15:03:16
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-12-24 14:36:31
 * @Description: 
 * @FilePath: /weryai-web/components/Tool/PromptTextarea.vue
-->
<template>
    <div class="mt-5">
        <label class="block text-white text-sm mb-[10px]">
            {{ title || t('tools.prompt') }}
        </label>

        <ClientOnly>
            <el-tooltip v-model:visible="tooltipVisible" effect="dark" trigger="hover"
                :placement="isLt1024 ? 'bottom' : 'right'" :disabled="tooltipDisabled" :enterable="true"
                popper-class="prompt-popper" :popper-style="popperStyle">
                <div class="relative w-full min-h-[127px] rounded-lg border border-white/[.06] p-[10px] transition-colors duration-200"
                    :class="[
                        {
                            'border-active-border': isFocused,
                            'hover:border-white/30 ': !is_disabled,
                        },
                        show_type === 'prompt_reversal' ? 'bg-[#28282b] border-white/10' : 'bg-tool-default-black',
                    ]" :style="{
                        borderColor: isFocused ? '#ffffff4d' : '',
                    }">
                    <textarea ref="textareaRef" v-model="prompt" :placeholder="!is_show_placeholder
                        ? ''
                        : placeholder || t('tools.describeImage')
                        " rows="5" :maxlength="maxLength" @input="handleInput" @focus="isFocused = true"
                        @blur="isFocused = false" :disabled="is_disabled"
                        class="w-full !p-0 border-none bg-transparent text-white placeholder:gray-300 text-base md:text-sm focus:outline-none focus:ring-0 focus:border-transparent resize-none overflow-y-auto leading-6 mb-[8px]"
                        style="min-height: 96px; max-height: 360px;"></textarea>
                    <div v-if="is_show_recommend"
                        class="absolute flex items-center gap-5 left-[10px] bottom-2 text-text-adad">
                        <span v-if="!loading"
                            class="text-text-adad text-xs flex items-center gap-1 group cursor-pointer hover:text-white transition duration-300"
                            @click="handleClickRecommendPrompt">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                                fill="none" class="w-4 h-4">
                                <path
                                    d="M3.14227 4.75207L2.97788 5.12919C2.85758 5.40528 2.47571 5.40528 2.35541 5.12919L2.19104 4.75207C1.89804 4.07965 1.3703 3.54427 0.71178 3.25139L0.205365 3.02615C-0.0684548 2.90435 -0.0684548 2.50587 0.205365 2.38408L0.683467 2.17143C1.35892 1.87101 1.89611 1.31582 2.18408 0.620552L2.35288 0.213023C2.47052 -0.0710075 2.86278 -0.0710075 2.98042 0.213023L3.14921 0.620552C3.43718 1.31582 3.97439 1.87101 4.64987 2.17143L5.12792 2.38408C5.40181 2.50587 5.40181 2.90435 5.12792 3.02615L4.62152 3.25139C3.96301 3.54427 3.43525 4.07965 3.14227 4.75207ZM10.2096 6.35523L10.3043 6.44994C11.1675 7.34533 11.5537 8.65787 11.2084 9.94673C10.7763 11.5595 9.31347 12.6656 7.66773 12.6656C6.31048 12.6656 4.52565 12.2484 3.01907 11.6561C3.82299 10.7131 4.11615 9.78333 4.219 8.53667C4.24383 8.23573 4.25934 8.11607 4.2879 8.00947C4.81694 6.03507 6.67787 4.93677 8.61567 5.45599C9.2366 5.62238 9.7774 5.93855 10.2096 6.35523ZM12.1519 1.58087L8.85907 4.14193C6.22816 3.49282 3.70562 5.03097 3 7.6644C2.93217 7.91753 2.91098 8.17467 2.88878 8.444C2.81219 9.37327 2.72369 10.4471 0.666667 11.9977C2.33333 12.9977 5.33333 13.9989 7.66773 13.9989C9.87613 13.9989 11.8975 12.5264 12.4963 10.2918C12.7224 9.44793 12.7185 8.59667 12.5231 7.80447L15.0835 4.51253C15.2899 4.24713 15.2665 3.86957 15.0287 3.63183L13.0325 1.6357C12.7948 1.39796 12.4173 1.37445 12.1519 1.58087ZM11.2635 5.52347C11.2213 5.47968 11.1782 5.43663 11.1343 5.39433L10.3846 4.64457L12.5059 2.99465L13.6697 4.15849L12.0198 6.27981L11.2635 5.52347Z"
                                    fill="currentColor" />
                            </svg>
                            {{ t('tools.recommendPrompt') }}</span>
                        <svg v-else xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14"
                            fill="none" class="w-4 h-4 loading hover:text-white cursor-pointer">
                            <path
                                d="M2.30838 1.62175C3.47704 0.611253 5.00047 0 6.66667 0C10.3485 0 13.3333 2.98477 13.3333 6.66667C13.3333 8.09073 12.8868 9.41053 12.1261 10.4937L10 6.66667H12C12 3.72115 9.6122 1.33333 6.66667 1.33333C5.23321 1.33333 3.93185 1.89885 2.97349 2.81895L2.30838 1.62175ZM11.0249 11.7116C9.85627 12.7221 8.33287 13.3333 6.66667 13.3333C2.98477 13.3333 0 10.3485 0 6.66667C0 5.24257 0.446527 3.92277 1.2072 2.83963L3.33333 6.66667H1.33333C1.33333 9.6122 3.72115 12 6.66667 12C8.10013 12 9.40147 11.4345 10.3599 10.5144L11.0249 11.7116Z"
                                fill="currentColor" />
                        </svg>
                        <span
                            class="text-text-adad text-xs flex items-center gap-1 group cursor-pointer hover:text-white transition duration-300"
                            @click="handleShowAIReversal">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12"
                                fill="none">
                                <path
                                    d="M10.158 0.2C10.41 0.2 10.631 0.437 10.631 0.708V4.429H13.534C13.628 4.429 13.724 4.464 13.786 4.531C14.006 4.701 14.07 5.005 13.913 5.241L10.221 11.163C10.1854 11.233 10.1314 11.2921 10.0648 11.3338C9.99821 11.3755 9.92156 11.3984 9.843 11.4C9.59 11.4 9.369 11.163 9.369 10.893V7.17H6.466C6.41928 7.17095 6.37285 7.1624 6.32953 7.14487C6.28621 7.12733 6.24691 7.10118 6.214 7.068C6.1061 6.98828 6.03289 6.87021 6.00945 6.73812C5.98601 6.60603 6.01412 6.46998 6.088 6.358L9.779 0.436C9.81473 0.36583 9.86888 0.306704 9.93564 0.264954C10.0024 0.223205 10.0793 0.200406 10.158 0.199V0.2ZM0.7 0H6.3C6.48565 0 6.6637 0.0737497 6.79498 0.205025C6.92625 0.336301 7 0.514348 7 0.7C7 0.885652 6.92625 1.0637 6.79498 1.19497C6.6637 1.32625 6.48565 1.4 6.3 1.4H0.7C0.514349 1.4 0.336301 1.32625 0.205025 1.19497C0.0737497 1.0637 0 0.885652 0 0.7C0 0.514348 0.0737497 0.336301 0.205025 0.205025C0.336301 0.0737497 0.514349 0 0.7 0ZM0.7 10H6.3C6.48565 10 6.6637 10.0737 6.79498 10.205C6.92625 10.3363 7 10.5143 7 10.7C7 10.8857 6.92625 11.0637 6.79498 11.195C6.6637 11.3263 6.48565 11.4 6.3 11.4H0.7C0.514349 11.4 0.336301 11.3263 0.205025 11.195C0.0737497 11.0637 0 10.8857 0 10.7C0 10.5143 0.0737497 10.3363 0.205025 10.205C0.336301 10.0737 0.514349 10 0.7 10ZM0.7 5H3.3C3.48565 5 3.6637 5.07375 3.79498 5.20503C3.92625 5.3363 4 5.51435 4 5.7C4 5.88565 3.92625 6.0637 3.79498 6.19497C3.6637 6.32625 3.48565 6.4 3.3 6.4H0.7C0.514349 6.4 0.336301 6.32625 0.205025 6.19497C0.0737497 6.0637 0 5.88565 0 5.7C0 5.51435 0.0737497 5.3363 0.205025 5.20503C0.336301 5.07375 0.514349 5 0.7 5Z"
                                    fill="currentColor" />
                            </svg>
                            {{ t('common.aiReversalShort') }}
                        </span>
                    </div>
                    <span class="text-xs absolute right-[10px] bottom-2 transition-colors duration-200" :class="{
                        'text-yellow-400': isNearLimit && !isAtLimit,
                        'text-red-400': isAtLimit,
                        'text-[#666]': !isNearLimit,
                    }">
                        {{ characterCount }}/{{ maxLength }}
                    </span>
                </div>
                <template #content>
                    <div
                        class="flex flex-col gap-[30px] min-w-[300px] md:max-w-[400px] max-w-[350px] min-h-[300px] max-h-[600px] overflow-y-auto">
                        <div v-if="loading" class="w-full h-full">
                            <l-dot-spinner v-if="isClient" size="40" speed="0.9"
                                color="var(--el-menu-active-color)"></l-dot-spinner>
                        </div>

                        <div v-else-if="
                            !recommend_list || recommend_list.length === 0
                        " class="text-white/80 text-sm">
                            {{ t('batchTools.noRecommend') }}
                        </div>

                        <div v-else class="flex flex-col items-start gap-[30px]">
                            <div v-for="(item, idx) in recommend_list" :key="idx"
                                class="flex flex-col items-start gap-[10px]">
                                <p>
                                    {{ item }}
                                </p>
                                <button
                                    class="border border-transparent bg-[#4D505D] rounded-[6px] px-4 py-[6px] hover:border-white/30 hover:text-text-active transition duration-300"
                                    @click="
                                        setCurrentRecommendPrompt(
                                            item as string
                                        )
                                        ">
                                    {{ t('common.use') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </template>
            </el-tooltip>
            <template #fallback>
                <div class="relative w-full min-h-[127px] rounded-lg border border-transparent p-[10px] hover:border-white/30 transition-colors duration-200"
                    :class="[
                        { 'border-active-border': isFocused },
                        show_type === 'prompt_reversal' ? 'bg-[#28282b]' : 'bg-item-default',
                    ]" :style="{
                        borderColor: isFocused ? '#ffffff4d' : '',
                    }">
                    <textarea ref="textareaFallbackRef" v-model="prompt"
                        :placeholder="placeholder || t('tools.describeImage')" rows="4" :maxlength="maxLength"
                        @input="handleInput" @focus="isFocused = true" @blur="isFocused = false"
                        class="w-full !p-0 border-none bg-transparent text-white placeholder:gray-300 text-base md:text-sm focus:outline-none focus:ring-0 focus:border-transparent resize-none overflow-y-auto leading-6"
                        style="min-height: 96px; max-height: 360px;"></textarea>
                    <div v-if="is_show_recommend" class="absolute left-[10px] bottom-2 text-text-adad">
                        <span v-if="!loading"
                            class="text-text-adad text-xs flex items-center gap-1 group cursor-pointer hover:text-text-active transition duration-300"
                            @click="handleClickRecommendPrompt">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                                fill="none" class="w-4 h-4 group-hover:text-white">
                                <path
                                    d="M3.14227 4.75207L2.97788 5.12919C2.85758 5.40528 2.47571 5.40528 2.35541 5.12919L2.19104 4.75207C1.89804 4.07965 1.3703 3.54427 0.71178 3.25139L0.205365 3.02615C-0.0684548 2.90435 -0.0684548 2.50587 0.205365 2.38408L0.683467 2.17143C1.35892 1.87101 1.89611 1.31582 2.18408 0.620552L2.35288 0.213023C2.47052 -0.0710075 2.86278 -0.0710075 2.98042 0.213023L3.14921 0.620552C3.43718 1.31582 3.97439 1.87101 4.64987 2.17143L5.12792 2.38408C5.40181 2.50587 5.40181 2.90435 5.12792 3.02615L4.62152 3.25139C3.96301 3.54427 3.43525 4.07965 3.14227 4.75207ZM10.2096 6.35523L10.3043 6.44994C11.1675 7.34533 11.5537 8.65787 11.2084 9.94673C10.7763 11.5595 9.31347 12.6656 7.66773 12.6656C6.31048 12.6656 4.52565 12.2484 3.01907 11.6561C3.82299 10.7131 4.11615 9.78333 4.219 8.53667C4.24383 8.23573 4.25934 8.11607 4.2879 8.00947C4.81694 6.03507 6.67787 4.93677 8.61567 5.45599C9.2366 5.62238 9.7774 5.93855 10.2096 6.35523ZM12.1519 1.58087L8.85907 4.14193C6.22816 3.49282 3.70562 5.03097 3 7.6644C2.93217 7.91753 2.91098 8.17467 2.88878 8.444C2.81219 9.37327 2.72369 10.4471 0.666667 11.9977C2.33333 12.9977 5.33333 13.9989 7.66773 13.9989C9.87613 13.9989 11.8975 12.5264 12.4963 10.2918C12.7224 9.44793 12.7185 8.59667 12.5231 7.80447L15.0835 4.51253C15.2899 4.24713 15.2665 3.86957 15.0287 3.63183L13.0325 1.6357C12.7948 1.39796 12.4173 1.37445 12.1519 1.58087ZM11.2635 5.52347C11.2213 5.47968 11.1782 5.43663 11.1343 5.39433L10.3846 4.64457L12.5059 2.99465L13.6697 4.15849L12.0198 6.27981L11.2635 5.52347Z"
                                    fill="currentColor" />
                            </svg>
                            {{ t('tools.recommendPrompt') }}</span>
                        <svg v-else xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14"
                            fill="none" class="w-4 h-4 loading hover:text-white cursor-pointer">
                            <path
                                d="M2.30838 1.62175C3.47704 0.611253 5.00047 0 6.66667 0C10.3485 0 13.3333 2.98477 13.3333 6.66667C13.3333 8.09073 12.8868 9.41053 12.1261 10.4937L10 6.66667H12C12 3.72115 9.6122 1.33333 6.66667 1.33333C5.23321 1.33333 3.93185 1.89885 2.97349 2.81895L2.30838 1.62175ZM11.0249 11.7116C9.85627 12.7221 8.33287 13.3333 6.66667 13.3333C2.98477 13.3333 0 10.3485 0 6.66667C0 5.24257 0.446527 3.92277 1.2072 2.83963L3.33333 6.66667H1.33333C1.33333 9.6122 3.72115 12 6.66667 12C8.10013 12 9.40147 11.4345 10.3599 10.5144L11.0249 11.7116Z"
                                fill="currentColor" />
                        </svg>
                    </div>
                    <span class="text-xs absolute right-[10px] bottom-2 transition-colors duration-200" :class="{
                        'text-yellow-400': isNearLimit && !isAtLimit,
                        'text-red-400': isAtLimit,
                        'text-sub-title': !isNearLimit,
                    }">
                        {{ characterCount }}/{{ maxLength }}
                    </span>
                </div>
            </template>
        </ClientOnly>
    </div>
    <ui-prompt-reversal v-model:visible="aiReversalVisible" @apply="handleApplyReversalPrompt"></ui-prompt-reversal>
</template>
<script setup lang="ts">
import { computed, ref, onMounted, onUnmounted, nextTick, watch } from 'vue'
import { useI18n } from '~/composables/useI18n'
import { emitter, emitRecommendPrompt } from '~/utils/emitter'
import { useMediaQuery } from '@vueuse/core'

const isLt1024 = useMediaQuery('(max-width: 1023.98px)') // true 表示 < 1024px

const { t, locale } = useI18n()

const props = defineProps({
    title: {
        type: String,
        default: '',
    },
    placeholder: {
        type: String,
        default: '',
    },
    is_show_recommend: {
        type: Boolean,
        default: true,
    },
    recommend_list: {
        type: Array,
        default: () => [],
    },
    is_show_placeholder: {
        type: Boolean,
        default: true,
    },
    is_show_reversal: {
        type: Boolean,
        default: true,
    },
    is_disabled: {
        type: Boolean,
        default: false,
    },
    show_type: {
        type: String,
        default: '',
        required: false,
    }
})
const prompt = defineModel('prompt', {
    type: String,
    default: '',
})

const loading = ref(false)
const isFocused = ref(false)
const textareaRef = ref<HTMLTextAreaElement | null>(null)
const textareaFallbackRef = ref<HTMLTextAreaElement | null>(null)

const adjustHeight = () => {
    nextTick(() => {
        const targets = [textareaRef.value, textareaFallbackRef.value]
        targets.forEach(target => {
            if (target) {
                target.style.height = 'auto'
                target.style.height = `${target.scrollHeight}px`
            }
        })
    })
}

const maxLength = defineModel('prompt_length_limit', {
    type: Number,
    default: 5000,
})

const tooltipVisible = ref(false)
// 点击「AI推荐提示词」后，允许 Tooltip 即使在列表为空时也强制弹出一次（用于显示“暂无推荐/加载中”）
const forceOpen = ref(false)
const tooltipDisabled = computed(() => {
    // 你要求：调用推荐接口的时候不需要展示 Tooltip
    if (loading.value) return true
    const hasRecommend = (props.recommend_list?.length || 0) > 0
    // hover 只在有推荐时显示；点击后强制打开一次（forceOpen=true）则允许显示空态
    return !forceOpen.value && !hasRecommend
})

const handleClickRecommendPrompt = () => {
    loading.value = true
    forceOpen.value = true

    // 请求期间不展示 Tooltip：如果当前正在显示，主动关闭
    tooltipVisible.value = false
    emitRecommendPrompt()
}

const aiReversalVisible = ref<boolean>(false)
const reversal_prompt = ref<string>('')
// AI提示词反推
const handleShowAIReversal = () => {
    aiReversalVisible.value = true
}

const handleInput = (event: Event) => {
    const target = event.target as HTMLTextAreaElement
    const value = target.value

    // 如果输入超过最大长度，截断到最大长度
    if (value.length > maxLength.value) {
        prompt.value = value.substring(0, maxLength.value)
        // 更新输入框的值
        target.value = prompt.value
    }

    adjustHeight()
}

const characterCount = computed(() => prompt.value.length)
const isNearLimit = computed(() => characterCount.value > maxLength.value * 0.8)
const isAtLimit = computed(() => characterCount.value >= maxLength.value)

const setCurrentRecommendPrompt = (item: string) => {
    prompt.value = item
    // 选中后关闭 Tooltip
    forceOpen.value = false
    tooltipVisible.value = false
    adjustHeight()
}

const handleResetRecommendLoading = () => {
    loading.value = false
    // 接口返回后再展示 Tooltip（即使列表为空，也展示“暂无推荐”）
    if (forceOpen.value) {
        nextTick(() => {
            tooltipVisible.value = true
        })
    }
}

// 应用反推提示词
const handleApplyReversalPrompt = (item: string) => {
    prompt.value = item
    adjustHeight()
}

watch(() => prompt.value, (newVal) => {
    if (newVal) {
        adjustHeight()
    }
}, { immediate: true })

// Tooltip 关闭后，恢复默认规则：仅在 recommend_list 有值时 hover 才能再打开
watch(
    () => tooltipVisible.value,
    v => {
        if (!v && !loading.value) {
            forceOpen.value = false
        }
    }
)

const isClient = ref(false)

onMounted(async () => {
    emitter.on('reset-recommend-loading', handleResetRecommendLoading)
    if (typeof window !== 'undefined') {
        try {
            const { dotSpinner } = await import('ldrs')
            dotSpinner.register()
            // 确保注册完成后再设置 isClient，避免组件在注册前渲染
            isClient.value = true
        } catch (error) {
            console.error('Failed to load ldrs:', error)
            // 即使加载失败也设置为 true，避免无限等待
            isClient.value = true
        }
    }
})

onUnmounted(() => {
    emitter.off('reset-recommend-loading', handleResetRecommendLoading)
})

const popperStyle =
    'font-size:13px;color:#fff;padding:20px;background: #333643;border-radius:16px;border:none;z-index:40'
</script>
<style scoped lang="less">
.loading {
    animation: loading 1s linear infinite;
    transition: all 0.2s ease-in-out;
}

@keyframes loading {
    0% {
        transform: rotate(0deg);
        color: var(--weryai-text-active);
    }

    100% {
        transform: rotate(360deg);
        color: var(--weryai-text-active);
    }
}

textarea::placeholder {
    color: #666;
}
</style>

<style>
.prompt-popper .el-popper__arrow:before {
    background: #333643 !important;
    border: none !important;
}
</style>
